const actions = {
  SET_STATE: "settings/SET_STATE",
  CHANGE_SETTING: "settings/CHANGE_SETTING",
  CHANGE_SETTING_BULK: "settings/CHANGE_SETTING_BULK",
};

export default actions;
